

// @ts-nocheck

import Vue from "vue";
import SurveyEdit from "./SVGs/SurveyEdit.vue";
import SurveyBin from "./SVGs/SurveyBin.vue";
import SurveyView from "./SVGs/SurveyView.vue";
import SurveyMove from "./SVGs/SurveyMove.vue";
import SurveyCheck from "./SVGs/SurveyCheck.vue";
import InlineTooltipQuestion from './InlineTooltipQuestion.vue'
import RatingScaleSelector from './RatingScaleSelector.vue'

export default Vue.extend({
  data() {
    return {
    };
  },
  computed: {
    compType(): string {
      return this.$store.getters["survey/stepField"]([this.compIndex, 'type'])      
    },
    noRemove(): boolean {
      return (this.compType === 'thankyou' && this.compIndex === this.$store.state.survey.surveyFlow.length - 1)  || this.childComp
    },
    noUp(): boolean {      
      if (this.compIndex == 1) {
        const aboveIsWelcome = this.$store.getters["survey/stepField"]([0, 'type']) === 'welcome'
        if (aboveIsWelcome) return true
      } 
      return this.compType === 'thankyou' || this.compIndex === 0
    },
    noDown(): boolean {      
      return this.compType === 'thankyou' || this.compIndex === this.$store.state.survey.surveyFlow.length - 1 || this.compIndex === this.$store.state.survey.surveyFlow.length - 2
    },
    ratingType(): string | false {
      return this.$store.state.survey.surveySetup.ratingType
    },   
    maximumRatingValue(): number {
      switch (this.ratingType) {        
        case "nps":
          return 10
        default:
          return 5
        }
    },
    minimumRatingValue(): number {
      switch (this.ratingType) {
        case "nps":
          return 0
        default:
          return 1
        }
    },
    allowSkip(): boolean {
      return this.$store.getters["survey/stepField"]([this.compIndex, 'allowSkip']) !== false
    },
    shareRating(): any {
      if (!this.hasRatingScale || this.ratingScaleIsShowAll) return ''      
      const value = this.$store.getters["survey/stepField"]([this.compIndex, 'showTo', 'ratingScale'])
      return [value.low,value.high]
    },
    getRatingString(): string {
      if (!this.hasRatingScale || this.ratingScaleIsShowAll) return ''      

      return String(this.shareRating[0] === this.shareRating[1] ? this.shareRating[0] : this.shareRating[0] + " to " + this.shareRating[1])

    },
    highlight(): boolean {
        const step = this.$store.state.survey.surveyFlow[this.compIndex]
        return step.uniqueID === this.$store.state.survey.stepHighlightIndex
    },
    hasCustomClosedSideContent(): boolean {
      return (!!this.$slots.closedsidecntnt) && this.showCustomClosedSideContent;
    },
    ratingScaleIsShowAll() : boolean {
      
      if (!this.hasRatingScale || this.childComp) return false
      
      return this.$store.getters["survey/stepField"]([this.compIndex, 'showTo', 'ratingScale']) === 'all' ? true : false

    }
  },
  //--------
  name: "surveystep",  
  //
  props: {
    title: String,
    desc: [String, Boolean],
    compIndex: Number,
    hasRatingScale: Boolean,
    descTooltip: {
      type: [String, Boolean],
      default: false
    },
    childComp: {
      type: Boolean,
      default: false
    },
    open: Boolean,
    draggable: {
      type: Boolean,
      default: true,
    },
    showCustomClosedSideContent: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    open(v) {
      // @ts-ignore
      const thisComp = this.$refs.thisstep as HTMLElement;
      if (!v) {
        const currentHeight = thisComp.offsetHeight;
        //noconsoleconsole.log(currentHeight);
        thisComp.style.minHeight = `${currentHeight}px`;
        // @ts-ignore
        thisComp.style.maxHeight = null;
        //add fixed width to comp
        setTimeout(() => {
          thisComp.style.minHeight = "0px";
        }, 1);
      } else {
        //compute current height
        const currentHeight = thisComp.offsetHeight;
        // @ts-ignore
        thisComp.style.minHeight = null;
        thisComp.style.maxHeight = `${currentHeight}px`;
        //add fixed width to comp
        setTimeout(() => {
          thisComp.style.maxHeight = "10000px";
        }, 1);
      }
    }
  },
  //--------
  methods: {       
    openClose() {
      this.$emit("openClose");
    },
    save() {
      this.$emit("save");
    },
  },
  //--------
  components: {
    SurveyView,
    SurveyEdit,
    SurveyBin,
    SurveyMove,
    SurveyCheck,
    InlineTooltipQuestion,
    RatingScaleSelector
  },
});
